<template lang="pug">
breadcrumbs-layout(
  bg="grey"
  :breadcrumbs="breadcrumbs"
)
  catalog-list(
    v-if="isContainData"
    :items="eventsList"
    :doubler="false"
  )
    filter-yellow(
      slot="prefix"
      v-bind="filterProps"
    )
    catalog-sort(
      slot="before"
      :key="sort"
      :items="sortList"
    )
    PaginatorDefault(
      v-if="pagesCount > 1"
      :count="pagesCount"
      :current="parseInt(page)"
      :max="6"
      slot="after"
    )
    SelectCount(
      :options="pageLimits"
      :value="limit"
      text="Программ на странице"
      slot="right"
      @change="pageLimitChange"
    )
  SiteMap(
    v-else
    title="К сожалению, нам не удалось найти ничего идеально подходящего."
    :map="mainNav"
  )
    filter-yellow(
      slot="sidebar"
      v-bind="filterProps"
    )
    | Попробуйте воспользовать формой слева используя менее узкие критерии подбора
    | или воспользуйтесь списком категорий для поиска программы.
</template>

<script>
import SiteMap from '@/components/layout/SiteMap.vue';
import ListEventLayout from '@/components/page/event-list';
import TransitionFade from '@/components/transition/Fade.vue';
import { Breadcrumbs as BreadcrumbsLayout } from '@/components/layout';
import { Filter as FormFilter } from '@/components/parts/form';
import { Yellow as FilterYellow } from '@/components/parts/filter';
import { Paginator as PaginatorDefault } from '@/components/parts/pagination';
import SelectCount from '@/components/parts/catalog/list/count';
import {
  List as CatalogList,
  Sort as CatalogSort,
} from '@/components/parts/catalog/list';

import mixin from '../mixin.js';
import MixinListCommon from '@/pages/mixin-list';
import mixinList from '../mixin-list.js';
import mixinFilter from '../../mixin-filter.js';
import mixinNav from '../../mixin-nav';
import routeProps from '@/mixins/routeProps.js';
import moduleShow from '@/mixins/moduleShow.js';

import createStoreModule from './store.js';

const STORE_MODULE_NAME = 'event_list';
const DEFAULT_SORT = 'cost';

const limits = [7, 19, 39];
const PAGE_SIZE = limits[1];
const PAGE_NUMBER = 1;

export default {
  storeName: STORE_MODULE_NAME,

  storeRegister: createStoreModule,

  asyncData({ store, route }) {
    const filtredQueryParams = {};

    for (const query in route.query) {
      if (route.query[query] === 0 || route.query[query])
        filtredQueryParams[query] = route.query[query];
    }

    const params = {
      page: PAGE_NUMBER,
      limit: PAGE_SIZE,
      ...filtredQueryParams,
      ...route.params,
      actual_schedule: 1,
    };

    return store.dispatch(`${STORE_MODULE_NAME}/init`, params);
  },

  components: {
    SiteMap,
    SelectCount,
    ListEventLayout,
    BreadcrumbsLayout,
    TransitionFade,
    FormFilter,
    FilterYellow,
    CatalogList,
    CatalogSort,
    PaginatorDefault,
  },

  mixins: [
    mixin,
    MixinListCommon,
    mixinList,
    mixinFilter,
    mixinNav,
    routeProps,
    moduleShow,
  ],

  sortNav: [
    {
      text: 'По стоимости',
      value: DEFAULT_SORT,
    },

    {
      text: 'Оценка по отзывам',
      value: 'reviews',
    },
  ],

  sortField: 'sort',
  limits,

  props: {
    sort: {
      type: String,
      default: DEFAULT_SORT,
    },

    page: {
      type: [String, Number],
      default: PAGE_NUMBER,
    },

    limit: {
      type: [String, Number],
      default: PAGE_SIZE,
    },
  },

  computed: {
    navSwitcher() {
      return this.$options.filterNav.map((item, index) => {
        const selected =
          item.variant === 'catalog'
            ? ['events', 'home'].includes(this.$route.name)
            : this.$route.name === 'map';
        return { ...item, selected };
      });
    },

    filterProps() {
      const { $options, localFilterFields, localFilterValues } = this;
      const key = JSON.stringify(localFilterValues);
      return {
        key,
        route: 'events',
        fields: localFilterFields,
        values: localFilterValues,
        nav: this.navSwitcher,
      };
    },

    localFilterValues() {
      const { $route, filterValues, limit, sort } = this;
      const addedValues = { sort, limit };
      if ($route.query.tags) {
        addedValues.tags = $route.query.tags;
      }
      return {
        ...filterValues,
        ...addedValues,
        ...$route.query,
      };
    },

    localFilterFields() {
      const { $route, filterFields } = this;
      const addedFields = [
        { type: 'hidden', code: 'sort' },
        { type: 'hidden', code: 'limit' },
      ];
      if ($route.query.tags) {
        addedFields.push({ type: 'hidden', code: 'tags' });
      }
      return [...filterFields, ...addedFields];
    },

    state() {
      return this.$store.state[STORE_MODULE_NAME];
    },

    sortList() {
      return this.$options.sortNav.map((item) => {
        let { text, value } = item;
        let to = {
          ...this.$route,
          query: {
            ...this.$route.query,
            page: PAGE_NUMBER,
          },
        };
        delete to.query.page;
        to.query[this.$options.sortField] = value;
        return { text, to, active: this.sort === value };
      });
    },

    isContainData() {
      return this.eventsList && this.eventsList.length > 0;
    },

    limits() {
      return this.$options.limits;
    },

    pageLimits() {
      return this.limits.map((item) => {
        return {
          text: item,
          value: item,
        };
      });
    },

    pagesCount() {
      return Math.ceil(this.state.count / this.limit);
    },
  },

  metaInfo() {
    const { logoImage, seoDescription, seoKeywords, seoTitle } =
      this.$store.state.regionProfile;
    return {
      title: seoTitle || 'Центр опережающей профессиональной подготовки',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content:
            seoDescription || 'Центр опережающей профессиональной подготовки',
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content:
            seoKeywords || 'блог, цопп, профессиональная, подготовка, центр',
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: seoTitle || 'Центр опережающей профессиональной подготовки',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            seoDescription || 'Центр опережающей профессиональной подготовки',
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: logoImage || '',
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// List.vue?27ac161c